export const formatNumberForDisplay = (value?: number | string, mode: 'commas' | 'space' = 'space') => {
  if (value === undefined || value === '') return '';

  const number = Number(value);
  if (isNaN(number)) return '';

  const [wholePartRaw, fractionalPartRaw] = number.toFixed(2).split('.');

  let formattedWholePart;
  if (mode === 'commas') {
    formattedWholePart = parseInt(wholePartRaw, 10).toLocaleString('en-US');
    return fractionalPartRaw === '00'
      ? formattedWholePart
      : `${formattedWholePart}.${fractionalPartRaw}`;
  } else {
    formattedWholePart = wholePartRaw.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return fractionalPartRaw === '00'
      ? formattedWholePart
      : `${formattedWholePart},${fractionalPartRaw}`;
  }
};
